module.exports = __webpack_public_path__ + "static/media/cafe24-body-stock.42cd7f42.png";